// Existing JavaScript code...

document.addEventListener("DOMContentLoaded", function () {
    const deliveryDateInput = document.getElementById("delivery-date");
    const deliveryTimeSelect = document.getElementById("delivery-time");

    // Set the minimum delivery date
    const today = new Date();
    today.setHours(today.getHours() + 3); // 3 hours later
    const minDeliveryDate = today.toISOString().split("T")[0];
    deliveryDateInput.setAttribute("min", minDeliveryDate);

    // Update available times based on the selected date
    deliveryDateInput.addEventListener("change", function () {
        const selectedDate = new Date(deliveryDateInput.value);
        const currentDate = new Date();
        if (selectedDate.toDateString() === currentDate.toDateString() && currentDate.getHours() >= 21) {
            selectedDate.setDate(selectedDate.getDate() + 1); // Move to next day
            deliveryDateInput.value = selectedDate.toISOString().split("T")[0];
        }

        // Adjust time options based on the selected date and time
        const now = new Date();
        const timeSlots = [...deliveryTimeSelect.options];
        timeSlots.forEach((option) => {
            const [hours, minutes] = option.value.split(':').map(Number);
            const deliveryTime = new Date(selectedDate);
            deliveryTime.setHours(hours, minutes);
            if (deliveryTime < now) {
                option.disabled = true; // Disable past time slots
            } else {
                option.disabled = false;
            }
        });
    });
});
